import {EquipmentType} from '@hconnect/common/types'

import {type EquipmentDto} from '../types'

export const getEquipmentDetailsByValue = (
  value: string,
  kilnLabel: string,
  plantEquipments?: EquipmentDto[]
) => {
  const equipmentFound = plantEquipments?.find(({equipmentNumber}) => equipmentNumber === value)
  if (equipmentFound) {
    return {description: equipmentFound.description, equipmentType: equipmentFound.equipmentType}
  }
  return {description: kilnLabel, equipmentType: EquipmentType.KILN}
}
